"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetTDisplayNameId = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = require("react");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _selectors = require("../redux/selectors");
var _constants = require("../utils/constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  temperatureRegex
} = _paulCorePackage.constants.regularsByDisplayNameId;
const {
  temperature
} = _constants.yAxisTypes;
const {
  empty
} = _constants.yAxisTypes;

/** @todo make refactoring */
const useGetTDisplayNameId = _ref => {
  let {
    chartId,
    equipmentType,
    equipmentId
  } = _ref;
  const [tDisplayNameId, setTDisplayNameId] = (0, _react.useState)([]);
  const [options, setOptions] = (0, _react.useState)([]);
  const {
    40: tTemper = '',
    66: tDisable
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const trV = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues);
  const displayNameIdList = (0, _reactRedux.useSelector)((0, _selectors.getDisplayNameIdListByChartId)(chartId));
  const chartData = (0, _reactRedux.useSelector)((0, _selectors.selectChartDataByParams)({
    chartId,
    equipmentType,
    equipmentId
  }), (prev, next) => _paulCorePackage.functions.areEqual(prev, next));
  const generalUnitsByDisplayNameId = (0, _react.useMemo)(() => Object.values(chartData).reduce((acc, device) => _objectSpread(_objectSpread({}, acc), Object.keys(device || {}).reduce((accV, valueKey) => {
    var _device$valueKey$find;
    return _objectSpread(_objectSpread({}, accV), {}, {
      [valueKey]: (_device$valueKey$find = device[valueKey].find(value => value.unit)) === null || _device$valueKey$find === void 0 ? void 0 : _device$valueKey$find.unit
    });
  }, {})), {}), [chartData]);
  (0, _react.useEffect)(() => {
    const {
      Default: {
        unit: activeTranslationsByUnit = {}
      } = {},
      [equipmentType]: {
        displayNameId: activeTranslationsByEquipmentType = {}
      } = {},
      Product: {
        displayNameId: activeTranslationsByProduct = {}
      } = {}
    } = trV;
    if (!displayNameIdList.length ||
    // don't display labels if no translations
    !Object.keys(activeTranslationsByEquipmentType).length && !Object.keys(activeTranslationsByProduct).length) {
      return;
    }
    setTDisplayNameId(displayNameIdList.reduce((acc, dId) => acc.concat({
      value: dId,
      label: activeTranslationsByEquipmentType[dId] || activeTranslationsByProduct[dId],
      unit: activeTranslationsByUnit[generalUnitsByDisplayNameId[dId]]
    }), []));
    setOptions(displayNameIdList.reduce((acc, dId) => {
      if (temperatureRegex.test(dId)) {
        const temperatureIndex = acc.findIndex(_ref2 => {
          let {
            type
          } = _ref2;
          return type === temperature;
        });
        if (temperatureIndex >= 0) {
          acc[temperatureIndex].value = "".concat(acc[temperatureIndex].value, ".").concat(dId);
          return acc;
        }
        return acc.concat({
          value: dId.toString(),
          label: tTemper,
          type: temperature,
          unit: activeTranslationsByUnit[generalUnitsByDisplayNameId[dId]]
        });
      }
      return acc.concat({
        value: dId.toString(),
        label: activeTranslationsByEquipmentType[dId] || activeTranslationsByProduct[dId],
        unit: activeTranslationsByUnit[generalUnitsByDisplayNameId[dId]]
      });
    }, []).concat({
      value: empty,
      label: tDisable,
      type: empty
    }));
  }, [displayNameIdList, trV, generalUnitsByDisplayNameId, tTemper, tDisable, equipmentType]);
  return {
    tDisplayNameId,
    options
  };
};
exports.useGetTDisplayNameId = useGetTDisplayNameId;